import { gql } from "@apollo/client";
export const GET_ROLES = gql`
    query GetRoles ($companyType:String!){
        roles(companyType:$companyType) {
            name
            normalizedName
            clientFacingName
            default
        }
    }
`;